import { Box, Stack, Typography } from "@mui/material"
import { FC } from "react"

import { useAuth0 } from "@auth0/auth0-react"
import logo from "../../assets/mobilus-logo.png"
import LoginButton from "./LoginButton"

export const PublicHomePage: FC = () => {
  const { isAuthenticated, isLoading } = useAuth0()

  if (isLoading) {
    // return <LoadingPage />
  }
  if (isAuthenticated) {
    // return <Navigate to="/" replace />
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        padding: 2,
      }}
    >
      <img src={logo} alt="Mobilus Logo" />
      <Typography variant="h3" component="div" gutterBottom mt={10}>
        Mobilus Dispatch
      </Typography>
      <Typography variant="body1" gutterBottom>
        Powered by Mobilus Technologies inc.
      </Typography>
      <Stack direction="column" spacing={2} mt={2} alignItems={"center"}>
        <LoginButton />
      </Stack>
    </Box>
  )
}
